import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    shops: [],
    posCheckoutStatus: [],
    checkoutDetails: {},
    defaultCurrency: '',
    product_sale_elements_by_categories: [],
    product_sale_elements: [],
    categories: [],
    // points rouges par boutique (get/shops/alerts) : { [shopId]: { ended_products, transfers_to_validate, overdue_credits, total } }
    alerts: {},

}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
